import React from 'react';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { DialogContent, DialogActions, Grid, InputLabel } from '@material-ui/core';
import Input from './Input';

export default function SubjectModal(props) {
  // const classes = useStyles();
  const {
    onClose,
    open,
    addSubject,
    handleChange,
    merchantName,
    agentSurname,
    agentName,
    agentPatronymic,
    phone,
    email,
    handleEditSubject,
    tableIndex,
  } = props;

  const handleClose = () => {
    onClose();
  };
  const validate = (state) => {
    return {
      //mobile: /((8|\+7)-?)?\(?\d{3}\)?-?\d{1}-?\d{1}-?\d{1}-?\d{1}-?\d{1}-?\d{1}-?\d{1}/.test(state.mobile),
      // phone: /^\+?380(39|50|63|66|67|68|70|73|80|90|91|92|93|94|95|96|97|98|99)\d{7}$/.test(state.phone),
      // phone: /^[+]?[\s.0-9]*[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/.test(state.communityPhone),
      phone: /^[+]?[\s.0-9]*[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/.test(state.phone),
      email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        String(state.email).toLowerCase()
      ),
      // communityName: /^[a-zA-ZА-ЕЖ-ЩЬЮЯа-еж-щьюяЇїІіЄєҐґ0-9]$/.test(state.communityName),
      // address: /^[a-zA-ZА-ЕЖ-ЩЬЮЯа-еж-щьюяЇїІіЄєҐґ0-9]$/.test(state.address),
      // url: /^[a-zA-ZА-ЕЖ-ЩЬЮЯа-еж-щьюяЇїІіЄєҐґ0-9]$/.test(state.url),
      merchantName: /^[0-9a-zA-ZА-ЕЖ-ЩЬЮЯа-еж-щьюяЇїІіЄєҐґ' -.`";:]+$/.test(state.merchantName),
      agentPatronymic: /^[0-9А-ЕЖ-ЩЬЮЯа-еж-щьюяЇїІіЄєҐґ' -.`";:]+$/.test(state.agentPatronymic),
      agentName: /^[0-9А-ЕЖ-ЩЬЮЯа-еж-щьюяЇїІіЄєҐґ' -.`";:]+$/.test(state.agentName),
      agentSurname: /^[0-9А-ЕЖ-ЩЬЮЯа-еж-щьюяЇїІіЄєҐґ' -.`";:]+$/.test(state.agentSurname),
      // url: /^[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/.test(state.url),
    };
  };

  const valid = validate(props);
  // console.log(val' -.`";:
  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
      <DialogTitle id="simple-dialog-title">Додати cуб'єкт</DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Input
              required
              id="merchantName"
              name="merchantName"
              label="Найменування суб'єкту, у якому буде застосовано МШ (Відділ соціального захисту населення, ЦНАП, старостат тощо) "
              onChange={handleChange}
              value={merchantName}
              valid={!valid.merchantName ? 1 : 0}
              inputProps={{ maxLength: 255 }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input
              onChange={handleChange}
              value={agentSurname}
              required
              id="agentSurname"
              name="agentSurname"
              label="Прізвище  уповноваженої особи "
              valid={!valid.agentSurname ? 1 : 0}
              inputProps={{ maxLength: 100 }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input
              onChange={handleChange}
              value={agentName}
              required
              id="agentName"
              name="agentName"
              label="Ім'я  уповноваженої особи "
              valid={!valid.agentName ? 1 : 0}
              inputProps={{ maxLength: 100 }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input
              required
              id="agentPatronymic"
              name="agentPatronymic"
              label="По батькові  уповноваженої особи"
              fullWidth
              onChange={handleChange}
              value={agentPatronymic}
              valid={!valid.agentPatronymic ? 1 : 0}
              inputProps={{ maxLength: 100 }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <InputLabel htmlFor="formatted-text-mask-input">Контактний телефон</InputLabel>
            <Input
              onChange={handleChange}
              value={phone}
              required
              id="phone"
              name="phone"
              label="Контактний телефон"
              phone
              valid={!valid.phone ? 1 : 0}
              // helperText="Формат заповненянн +380ХХХХХХХХХ"
              inputProps={{ maxLength: 20 }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input
              onChange={handleChange}
              value={email}
              required
              id="email"
              name="email"
              label="Адреса електронної пошти "
              valid={!valid.email ? 1 : 0}
              inputProps={{ maxLength: 255 }}
              fullWidth
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={handleClose}>
          Відміна
        </Button>

        {tableIndex !== '' ? (
          <Button
            variant="contained"
            color="primary"
            onClick={handleEditSubject}
            disabled={
              !valid.merchantName ||
              !valid.agentSurname ||
              !valid.agentName ||
              !valid.agentPatronymic ||
              !valid.phone ||
              !valid.email
            }
          >
            Редагувати
          </Button>
        ) : (
          <Button
            variant="contained"
            color="primary"
            onClick={addSubject}
            disabled={
              !valid.merchantName ||
              !valid.agentSurname ||
              !valid.agentName ||
              !valid.agentPatronymic ||
              // || !valid.phone
              !valid.email
            }
          >
            Додати
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
